const BASE_URL = 'https://api.dev.auxo.dk';

/**
 * Henter en enkelt CMS-post baseret på dens slug og sprogkode ('da').
 * @param {string} slug 
 * @returns {Promise<any>}
 */
export async function fetchBySlug(slug) {
  try {
    const response = await fetch(`${BASE_URL}/public/by-slug/da/${slug}`);
    if (!response.ok) {
      throw new Error(`Kunne ikke hente indhold for slug: ${slug}`);
    }
    return await response.json();
  } catch (error) {
    console.error('CMS Fetch Error:', error);
    return null;
  }
}

/**
 * Henter en hel CMS-kollektion via v2-endpointet.
 * @param {string} collectionName 
 * @param {Record<string, string>} [params] 
 * @returns {Promise<{ items: any[], total: number }>}
 */
export async function fetchCollection(collectionName, params = {}) {
  try {
    const query = new URLSearchParams(params).toString();
    const url = `${BASE_URL}/public/v2/content/${collectionName}${query ? `?${query}` : ''}`;
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Kunne ikke hente kollektion: ${collectionName}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`CMS Collection Fetch Error (${collectionName}):`, error);
    return { items: [], total: 0 };
  }
}
